import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import jsPDF from "jspdf";
import "./BrokerAppointmentForm.css";

const BrokerAppointmentForm = ({ fullName = "", address = "", onFinish }) => {
  const [clientName, setClientName] = useState(fullName);
  const [clientAddress, setClientAddress] = useState(address);
  const [isTopazAvailable, setIsTopazAvailable] = useState(false);

  const topazCanvasRef = useRef(null);
  const sigCanvasRef = useRef(null);
  const [sigObj, setSigObj] = useState(null);
  const [signatureData, setSignatureData] = useState("");

  useEffect(() => {
    if (window.Topaz) {
      setIsTopazAvailable(true);
    }
  }, []);

  const startTopazCapture = () => {
    if (window.Topaz) {
      const sig = new window.Topaz.UserControl();
      sig.JustifyMode = 0;
      sig.SetTabletState(1, topazCanvasRef.current.id);
      setSigObj(sig);
    }
  };

  const clearSignature = () => {
    if (isTopazAvailable) {
      if (sigObj) {
        sigObj.ClearTablet();
        setSignatureData("");
      }
    } else {
      sigCanvasRef.current.clear();
      setSignatureData("");
    }
  };

  const saveSignature = () => {
    if (isTopazAvailable) {
      if (sigObj) {
        const base64Image = sigObj.GetSigImageB64();
        setSignatureData(base64Image);
      }
    } else {
      const base64Image = sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png").split(",")[1];
      setSignatureData(base64Image);
    }
  };

  const handleFinish = async () => {
    const doc = new jsPDF();
    const marginLeft = 20;
    let cursor = 20;

    doc.setFontSize(12);
    doc.text(clientName, marginLeft, cursor);
    cursor += 7;
    doc.text(clientAddress, marginLeft, cursor);
    cursor += 12;

    doc.text("The Director/Secretary,", marginLeft, cursor);
    cursor += 7;
    doc.text("Apex Insurance Brokers Inc.,", marginLeft, cursor);
    cursor += 7;
    doc.text("125 C Barrack Street,", marginLeft, cursor);
    cursor += 7;
    doc.text("Kingston Georgetown.", marginLeft, cursor);
    cursor += 14;

    doc.text("Dear Sir,", marginLeft, cursor);
    cursor += 10;

    const body = [
      "I hereby appoint APEX INSURANCE BROKERS INC. as my Broker in respect to all my insurance",
      "matters and further authorise Apex to deal with any insurance company on my behalf.",
      "Such company is obliged to recognise Apex as my broker.",
      "",
      "This appointment does not preclude me from any decision regarding the placement of",
      "my insurance business.",
      "",
      "This letter supersedes any existing arrangement and/or contract with any other",
      "Broker or with any Agent."
    ];

    body.forEach(line => {
      doc.text(line, marginLeft, cursor);
      cursor += 7;
    });

    cursor += 10;
    doc.text("Yours Sincerely,", marginLeft, cursor);
    cursor += 10;
    doc.text(clientName, marginLeft, cursor);
    cursor += 15;

    if (signatureData) {
      doc.addImage(`data:image/png;base64,${signatureData}`, "PNG", marginLeft, cursor, 60, 25);
      cursor += 25;
    }

    const blob = doc.output("blob");
    const file = new File([blob], `broker_appointment_${Date.now()}.pdf`, {
      type: "application/pdf",
    });

    onFinish(file);
  };

  return (
    <div className="broker-form-container">
      <div className="broker-letter-inputs">
        <input
          type="text"
          className="client-name-input"
          placeholder="Your Full Name"
          value={clientName}
          onChange={(e) => setClientName(e.target.value)}
        />
        <input
          type="text"
          className="client-name-input"
          placeholder="Your Address"
          value={clientAddress}
          onChange={(e) => setClientAddress(e.target.value)}
        />
      </div>

      <div className="signature-section">
        <p>Signature ({isTopazAvailable ? "Topaz Device" : "Touch/Mouse"})</p>

        {/* ✅ Topaz Canvas */}
        {isTopazAvailable && (
          <canvas
            ref={topazCanvasRef}
            id="signatureCanvas"
            width="400"
            height="150"
            style={{ border: "2px solid black" }}
          ></canvas>
        )}

        {/* ✅ Fallback React Signature Pad */}
        {!isTopazAvailable && (
          <SignatureCanvas
            ref={sigCanvasRef}
            penColor="black"
            canvasProps={{ width: 400, height: 150, className: "signature-canvas" }}
          />
        )}
      </div>

      <div className="signature-buttons">
        {isTopazAvailable && (
          <button type="button" onClick={startTopazCapture}>Start Topaz Capture</button>
        )}
        <button type="button" onClick={clearSignature}>Clear Signature</button>
        <button type="button" onClick={saveSignature}>Save Signature</button>
        <button type="button" onClick={handleFinish}>Finish & Upload</button>
      </div>

      {signatureData && (
        <div style={{ marginTop: "20px" }}>
          <h4>Captured Signature Preview:</h4>
          <img src={`data:image/png;base64,${signatureData}`} alt="Signature Preview" />
        </div>
      )}
    </div>
  );
};

export default BrokerAppointmentForm;
